import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import PageTransition from './components/PageTransition';
import Chatbot from './components/Chatbot';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const DecouvrezNousPage = lazy(() => import('./pages/DecouvrezNousPage'));
const FormsPage = lazy(() => import('./pages/FormsPage'));
const TestPage = lazy(() => import('./pages/TestPage'));
const HeroTestComponent = lazy(() => import('./components/HeroTestComponent'));
const MentionsLegales = lazy(() => import('./pages/MentionsLegales'));
const PolitiqueConfidentialite = lazy(() => import('./pages/PolitiqueConfidentialite'));
const CGV = lazy(() => import('./pages/CGV'));
const Cookies = lazy(() => import('./pages/Cookies'));
const EmailTestComponent = lazy(() => import('./components/EmailTestComponent'));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-acid-green"></div>
  </div>
);

function App() {
  return (
    <div className="App bg-black min-h-screen">
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          
          <main className="relative bg-black">
            <PageTransition>
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/a-propos" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/decouvrez-nous" element={<DecouvrezNousPage />} />
                  <Route path="/forms" element={<FormsPage />} />
                  <Route path="/mentions-legales" element={<MentionsLegales />} />
                  <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
                  <Route path="/cgv" element={<CGV />} />
                  <Route path="/cookies" element={<Cookies />} />

                  <Route path="/test" element={<TestPage />} />
                  <Route path="/test-hero" element={<HeroTestComponent />} />
                  <Route path="/test-email" element={<EmailTestComponent />} />
                </Routes>
              </Suspense>
            </PageTransition>
          </main>
          
          <Footer />
          <ScrollToTopButton />
          <Chatbot />
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App; 